module.exports = __webpack_public_path__ + "bv-text.6c8ae68027eb35bd617304c2c1c931cc.svg";